document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.carousel-row').forEach(function (carousel) {
    carousel.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        carousel.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });
  });
});
